export const SITUACION_INMUEBLE_MODELO_347_ENUM = {
  EXCEPTO_PAIS_VASCO_Y_NAVARRA: 1,
  PAIS_VASCO_O_NAVARRA: 2,
  SITUACIONES_ANTERIORES_SIN_REFEERENCIA_CATASTRAL: 3,
  EXTRANJERO: 4,
} as const

export type TipoSituacionInmuebleType =
  (typeof SITUACION_INMUEBLE_MODELO_347_ENUM)[keyof typeof SITUACION_INMUEBLE_MODELO_347_ENUM]
